<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="userId">
        <el-cascader
            placeholder="代理商"
            ref="myCascader"
            :options="agentTree"
            :props="{ value : 'userId' , label : 'name' , checkStrictly: true,emitPath : false }"
            :show-all-levels="false"
            clearable
            v-model="queryParams.userId"
            @change="search"
            filterable
        ></el-cascader>
      </el-form-item>
      <el-form-item prop="isShow">
        <el-select v-model="queryParams.isShow" filterable clearable placeholder="是否上架" @change="search">
          <el-option label="未上架" value="0"></el-option>
          <el-option label="已上架" value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="success" icon="el-icon-plus" @click="addInternationalProduct">添加套餐</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border id="out-table">
        <el-table-column prop="ids" label="序号" align="center" width="60px"></el-table-column>
        <el-table-column prop="company" label="代理商" align="center" width="260px"></el-table-column>
        <el-table-column prop="productName" label="资费套餐" align="center" width="230px">
            <template slot-scope="scope">
            <div v-if="showAdmin">【{{scope.row.productId}}】{{scope.row.productName}}</div>
            <div v-else>{{scope.row.productName}}</div>
            </template>
        </el-table-column>
        <el-table-column prop="type" label="类型" align="center" width="100px">
            <template slot-scope="scope">
            <div v-if="scope.row.type == '1'">流量套餐</div>
            <div v-if="scope.row.type == '2'">短信套餐</div>
            <div v-if="scope.row.type == '3'">国际套餐</div>
            </template>
        </el-table-column>
        <el-table-column label="简介" align="center" width="840px">
            <template slot-scope="{row}">
            <div class="product-list">
                <div class="product-item" v-for="(item,index) in row.unitProducts.slice(0, 3)" :key="index" 
                    :title="'【'+item.countryName+'】'+'底价('+ item.currencySymbol + item.basePrice +')'+' 售价('+item.currencySymbol + item.price +')'+' 市场价('+item.currencySymbol + item.marketPrice +')'">

                    <span>【{{item.countryName}}】：</span><span style="margin-left:10px">底价({{item.currencySymbol}}{{item.basePrice}})</span>
                    <span style="margin-left:10px">售价({{item.currencySymbol}}{{item.price}}) </span>
                    <span style="margin-left:10px" v-if="item.marketPrice>0">市场价({{item.currencySymbol}}{{item.marketPrice}})</span>
                </div>
                <span class="el-dropdown-link" v-if="row.unitProducts.length>3" @click="showMoreProduct(row)">
                  <i class="el-icon-d-arrow-right el-icon--right"></i>更多
                </span>
            </div>
            </template>
        </el-table-column>
        <el-table-column prop="isShow" label="是否上架" align="center">
            <template slot-scope="{row}">
            <el-tag v-if="row.isShow == '1'">已上架</el-tag>
            <el-tag v-if="row.isShow == '0'" type="danger">未上架</el-tag>
            </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="120">
            <template slot-scope="{row}">
            <el-button size="mini" type="primary" plain  icon="el-icon-edit" @click="handleEdit(row)" >编辑</el-button>
            </template>
        </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="queryInfo"
    />
    <base-product v-if="showInternationalProduct" :show="showInternationalProduct" :baseId="baseId" @update-show="updateShow"></base-product>
    <el-dialog title="区域价格列表" :visible.sync="moreProductOpen" width="900px" append-to-body :close-on-click-modal="false">
      <el-input placeholder="请输入内容" v-model="searchQuery" clearable style="width: 30%"></el-input>
      <el-table :key="tableKey" :data="filteredTableData" height="650"  style="width: 100%">
        <el-table-column prop="countryName" label="使用区域"></el-table-column>
        <el-table-column prop="basePrice" label="底价">
          <template slot-scope="scope">
            {{scope.row.currencySymbol}}{{scope.row.basePrice}}
          </template>
        </el-table-column>
        <el-table-column prop="price" label="售价">
          <template slot-scope="scope">
            {{scope.row.currencySymbol}}{{scope.row.price}}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import {agentTreeList} from "@/api/api.js"; //新建套餐代理商
import { baseProductPage } from "@/api/api.js"; //获取列表
import BaseProduct from './BaseProduct.vue'

export default {
  name: "internationalBasePackage",
  components: {
    BaseProduct
  },
  data() {
    return {
      queryParams: {
        userId:undefined,
        isShow:undefined,
        operationIds:['4']
      },
      tableData: [],
      // 分页器
      page: 1,
      pageSize: 20,
      total: 20,
      // 代理商
      agentTree: [],
      title: "创建代理商资费",
      showInternationalProduct:false,
      baseId:null,
      moreProductOpen:false,
      searchQuery:'',
      moreProductData: [],
      tableKey: 0,
    };
  },
  computed: {
    showAdmin(){
        return this.$store.getters.user.userType =='1'; 
    },
    filteredTableData() {
      if (!this.moreProductData) return [];
      return this.moreProductData.filter(row => {
        return Object.values(row).some(value => {
          return String(value).toLowerCase().includes(this.searchQuery.toLowerCase());
        });
      });
    }

  },
  methods: {
    updateShow(show){
      this.showInternationalProduct = show;
      this.queryInfo()
    },
    //代理商列表
    handleAgentTreeList(){
      agentTreeList().then(res => {
        this.agentTree = res.data.data;
      });
    },
    // 获取列表
    queryInfo() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      baseProductPage(params).then(res => {
        if (res.data.code == 200) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.records;
          this.tableData.map((item,index)=>{
            item.ids  = index + 1
            
          })
        }else{
          this.$message.error(res.data.message)
        }
      });
    },
    // 搜索
    search() {
      this.page = 1,
      this.queryInfo();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.queryInfo();
    },
    addInternationalProduct(){
      this.baseId = null
      this.showInternationalProduct = true;
    },
    // 修改
    handleEdit(row) {
        this.baseId = row.id
        this.showInternationalProduct = true
    },
    showMoreProduct(item){
      this.moreProductOpen = true
      this.searchQuery = '';
      this.moreProductData = [];
      this.$nextTick(() => {
        this.moreProductData = [...item.unitProducts]; 
        this.tableKey++;
      });
    },
  },
  created() {
    this.queryInfo();
    this.handleAgentTreeList();
  },
};
</script>
<style scoped lang="less">
.product-list{
  display: flex; /* 或者 inline-flex */
  flex-wrap: wrap; /* 允许元素在需要时换行 */
  width: 820px;
  color: #409eff;
  .product-item{
    border: 1px solid #dcdfe6;
    width: 400px; /* 设置子元素的宽度 */
    white-space: nowrap;
    overflow: hidden; /* 隐藏超出容器的文本 */
    text-overflow: ellipsis; /* 使用省略号表示文本被截断 */
    height: 30px; /* 设置子元素的高度 */
    margin: 5px; /* 设置子元素的外边距 */
    background: #ecf5ff; /* 设置背景颜色 */
    line-height: 30px;
    align-content: flex-start;
    border-color: #b3d8ff;
    border-radius: 6px;
  }
  .el-dropdown-link{
    cursor: pointer;
    color: #409EFF;
    margin-left: 5px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 30px;
    margin: 5px;
    line-height: 30px;
    -ms-flex-line-pack: start;
    align-content: flex-start;

  }
}
</style>